var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M2.516-11.484A7.47,7.47,0,0,1,8-13.75a7.47,7.47,0,0,1,5.484,2.266A7.47,7.47,0,0,1,15.75-6,7.47,7.47,0,0,1,13.484-.516,7.47,7.47,0,0,1,8,1.75,7.47,7.47,0,0,1,2.516-.516,7.47,7.47,0,0,1,.25-6,7.47,7.47,0,0,1,2.516-11.484Z",
    transform: "translate(-0.25 13.75)",
    fill: "#2a66bf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.c368c6c418fb10b952579c87d18663c8.svg";
export { ForwardRef as ReactComponent };